import { useCallback, useMemo } from "react";

import { Blueprint } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import { BlueprintSuggestions } from "shared/Blueprint/constants";

import useBlueprintsAnalytics from "../../hooks/useBlueprintsAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const BlueprintsTableSpaceCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const trackAnalytics = useBlueprintsAnalytics();

  const spaceFilterAction = useCellFilterAction({
    filterName: BlueprintSuggestions.Space,
    filterValue: blueprint.space.id,
    spaceCell: true,
  });

  const handlePress = useCallback(() => {
    trackAnalytics("Space link clicked");
  }, [trackAnalytics]);

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellSpace href={`/spaces/${blueprint.space.id}`} onPress={handlePress}>
        {blueprint.space.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default BlueprintsTableSpaceCell;
